<div class="evaluation">
    <div class="evaluation-content">
        <div class="left">
            <div class="header">
                <div class="col">
                    <span>
                        {{
                            getSideContainerHeader(SideContainerPosition.LEFT)
                                | translate
                        }}
                    </span>
                </div>
            </div>
            <div class="data">
                <div class="side-content-wrapper">
                    <app-side-container
                        [side]="SideContainerPosition.LEFT"
                        *ngIf="!isDiagramMode || graphDataAvailable"
                    ></app-side-container>
                </div>
            </div>
        </div>
        <div class="central">
            <div class="header">
                <p class="toggle-label-eval">
                    {{
                        'evaluation.' +
                            training?.trainingType +
                            '.diagrams.toggle' | translate
                    }}
                </p>
                <div
                    class="toggle-wrapper"
                    [class.checked]="!isDiagramMode"
                    (click)="onToggle()"
                >
                    <div class="toggle-knob"></div>
                </div>
                <p class="toggle-label-play">
                    {{
                        'evaluation.' + training?.trainingType + '.media.toggle'
                            | translate
                    }}
                </p>
            </div>
            <div class="data">
                <div class="central-content-wrapper">
                    <div
                        class="no-data-message-container"
                        *ngIf="isDiagramMode && !graphDataAvailable"
                    >
                        <p>
                            {{
                                'evaluation.SL.diagrams.noDataMessage'
                                    | translate
                            }}
                        </p>
                    </div>
                    <app-line-chart
                        *ngIf="isDiagramMode && graphDataAvailable"
                        class="plot"
                        [tooltipLabel]="mapTooltipLabel"
                        [idPrefix]="'costs-svg'"
                        [dataSource]="iterationDataService.costOut"
                        [xAxisLabelSource]="evalDataStorage.xAxisLabel"
                        [yAxisLabelSource]="evalDataStorage.yAxisLabel"
                        [maxNumberEpoch]="maxNumberEpochs"
                        (clickEvent)="clickOnIteration($event)"
                    ></app-line-chart>
                    <div
                        class="video-container"
                        *ngIf="
                            training?.trainingType === TrainingType.MOTORIC &&
                            !isDiagramMode
                        "
                    >
                        <app-video-player
                            [id]="training.uuid"
                        ></app-video-player>
                    </div>
                    <app-image-viewer
                        *ngIf="
                            training?.trainingType === TrainingType.VISUAL &&
                            !isDiagramMode &&
                            initialized
                        "
                        [selectedImageIndexInAllImages]="selectedImageIndex"
                        [trainingId]="training.uuid"
                    ></app-image-viewer>
                </div>
            </div>
        </div>
        <div class="right">
            <div class="header">
                <div class="col">
                    <span>
                        {{
                            getSideContainerHeader(SideContainerPosition.RIGHT)
                                | translate
                        }}
                    </span>
                </div>
            </div>
            <div class="data">
                <div class="side-content-wrapper">
                    <app-side-container
                        [side]="SideContainerPosition.RIGHT"
                        *ngIf="!isDiagramMode || graphDataAvailable"
                    ></app-side-container>
                </div>
            </div>
        </div>
    </div>
</div>
